module.exports = __webpack_public_path__ + "img/topup_orange.a732e3f0.svg";